import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { AirTabs } from '@/features/air/components/tabs'
import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { Section, SectionTitle } from '@/features/app-shell/section'

export const Route = createFileRoute('/_dashboard/air/_layout/')({
	beforeLoad: () => {
		throw redirect({ to: '/air/overview' })
	},
	head: () => ({
		meta: [
			{
				title: 'Air | BitLyft AIR®',
			},
		],
	}),
	component: RouteComponent,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<Section>
			<SectionTitle>BitLyft AIR®</SectionTitle>
			<AirTabs />

			<Outlet />
		</Section>
	)
}
